import {axios as http} from "@/plugins/http"

export default class Api {
    static wish(wishId) {
        let config = {
            params: {
                wish_id: wishId,
            },
        }

        return http.get("/api/v1/wishlist/wish", config).then((resp) => {
            return resp.data["item"]
        })
    }
}
